import { rangeObj } from 'src/components/date_picker/dates';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const rangeObject = rangeObj();

const initialState = {
  order: rangeObject.thismonth,
  returnOrder: rangeObject.thismonth,
  inbound: rangeObject.thismonth,
  outbound: rangeObject.today,
  bulkOutbound: rangeObject.thisweek,
  bulkPicking: rangeObject.today,
  picking: rangeObject.today,
  purchaseOrder: rangeObject.thismonth,
  dashboard: rangeObject.today,
};

const store = (set, get) => ({
  ...initialState,

  setDate: (page, date) => {
    set((prev) => ({ ...prev, [page]: date }));
  },
  getDate: (page) => {
    var temp = get()[page];
    if (!temp || !temp.period) {
      temp = rangeObject.thismonth;
    }
    temp.period.until = new Date(temp.period.until);
    temp.period.since = new Date(temp.period.since);
    return temp;
  },
  reset: () => {
    set(initialState);
  },
});

const dateStore = create(
  persist(store, {
    name: 'date',
    storage: createJSONStorage(() => localStorage),
  }),
);

export default dateStore;
